import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 38 38"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M24.908 9.008a.362.362 0 0 0-.17.006l-3.72.968a.376.376 0 0 0-.27.457.373.373 0 0 0 .459.268l2.684-.697c-1.443 2.009-3.463 4.08-5.141 5.248-2.26 1.572-4.55 2.539-6.994 2.957a.375.375 0 0 0 .129.74c2.556-.438 4.942-1.447 7.295-3.084 1.725-1.199 3.788-3.31 5.277-5.365l-.002 2.752a.375.375 0 0 0 .75 0l.002-3.881a.376.376 0 0 0-.299-.37zm-.084 8.219a.375.375 0 0 0-.375.375v9.193c0 .065.021.123.05.176h-5.34v-6.192a.375.375 0 0 0-.75 0v6.192h-5.311c.007-.028.02-.056.02-.086v-3.989a.375.375 0 0 0-.75 0v3.989c0 .03.01.058.017.086h-3.01a.375.375 0 0 0 0 .75h18.828a.375.375 0 0 0 0-.75H25.15a.362.362 0 0 0 .05-.176v-9.193a.375.375 0 0 0-.376-.375z"
    }, null, -1)
  ])))
}
export default { render };